<div class="p-fluid" style="z-index: 5000;">
    <!-- <p-scrollPanel [style]="{width: '100%', height: '60vh'}"> -->
    <p-tree [value]="data" selectionMode="single" [(selection)]="selectedFile" (onNodeSelect)="nodeSelect($event)"
        (onNodeExpand)="espansioneNodo($event)"></p-tree>
    <!-- </p-scrollPanel> -->
</div>